import React from 'react';
import './video-library-carousel.scss';
import '../../onboarding-global-components/video-tiles/video-tile/video-tile.scss';
import { LibraryCarouselItem } from '../library-carousel-item/library-carousel-item';
import { useHowToVideoContent } from '../../../../hooks/dyf/use-how-to-video-content/use-how-to-video-content';

interface Props {
    videoCategories: any;
}
export const VideoLibraryCarousel = (props: Props) => {
    const quickTipsVideos = props.videoCategories['QUICK TIPS'];
    const moreVehicleTopics = props.videoCategories['MORE VEHICLE TOPICS'];
    const otherCategories = Object.keys(props.videoCategories)
        .filter(item => item.toLowerCase() !== 'quick tips')
        .filter(item => item.toLowerCase() !== 'more vehicle topics')
        .map(item => props.videoCategories[item]);
    if (moreVehicleTopics) {
        otherCategories.push(moreVehicleTopics);
    }
    const howToVideoContent = useHowToVideoContent();
    return (
        <div className="video-library-carousel-wrapper">
            {quickTipsVideos && (
                <div className="quickTipsWrapper">
                    <div className="quickTipsContent">
                        <LibraryCarouselItem
                            carouselContent={quickTipsVideos}
                            categoryTitle={
                                quickTipsVideos[0].custom_fields.category1
                            }
                            accountId={quickTipsVideos[0].account_id}
                            categoryDesc={
                                quickTipsVideos[0].custom_fields
                                    .categorydescription
                            }
                        />
                    </div>
                </div>
            )}
            <div className="video-library-carousel-container">
                {quickTipsVideos && howToVideoContent && (
                    <div className="library-wrapper" tabIndex={0}>
                        {howToVideoContent?.viewAllHtvTitle.toUpperCase()}

                        <div className="library-divider" />
                    </div>
                )}

                {otherCategories.map(item => {
                    return (
                        <div className="LibraryCarouse-{index}" key={item.id}>
                            <LibraryCarouselItem
                                carouselContent={item}
                                categoryTitle={item[0].custom_fields.category1}
                                categoryDesc={
                                    item[0].custom_fields.categorydescription
                                }
                                accountId={item[0].account_id}
                            />
                            <div className="library-divider" />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
